"use strict";

import { AppDispatcher } from 'Dispatcher';
import { FormConstants } from "Constants/Forms/FormConstants";
export function formDestroyed(formUUID) {
  AppDispatcher.asyncDispatch({
    actionType: FormConstants.FORM_DESTROYED,
    formUUID: formUUID
  });
}
export function navigateToParent(formUUID) {
  AppDispatcher.dispatch({
    actionType: FormConstants.NAVIGATE_TO_PARENT,
    formUUID: formUUID
  });
}
export function formSubmit(formUUID, applyMode) {
  AppDispatcher.dispatch({
    actionType: FormConstants.FORM_SUBMIT,
    formUUID: formUUID,
    applyMode: applyMode
  });
}
export function formFocusTable(tableUUID) {
  AppDispatcher.asyncDispatch({
    actionType: FormConstants.FORM_FOCUS_TABLE,
    tableUUID: tableUUID
  });
}